
import React from "react";
import PdfFormPreview from "app/pages/Docgen/components/common/preview-form/PdfFormPreview";
import Div from "@jumbo/shared/Div/Div";
import Form_SB_28 from "app/pages/Docgen/components/xfa-forms/Form_SB_28";
import Form_ADS from "app/pages/Docgen/components/xfa-forms/Form_ADS";
import Form_SB_08 from "app/pages/Docgen/components/xfa-forms/Form_SB_08";
import Form_SB_16 from "app/pages/Docgen/components/xfa-forms/Form_SB_16";
import Form_SB_30 from "app/pages/Docgen/components/xfa-forms/Form_SB_30";

const FormDetailsTab = ({ formData }) => {

    let formComponent;
    const formCode = formData?.data?.form_code;
    const selectedForm = formData?.data?.id;

    switch (formCode) {
        case "SB-28":
            formComponent = <Form_SB_28 selectedForm={selectedForm}/>;
            break;
        case "AIA-14":
            formComponent = <Form_ADS selectedForm={selectedForm}/>;
            break;
        case "SB-08":
            formComponent = <Form_SB_08 selectedForm={selectedForm}/>;
            break;
        case "SB-16":
            formComponent = <Form_SB_16 selectedForm={selectedForm}/>;
            break;
        case "SB-30":
            formComponent = <Form_SB_30 selectedForm={selectedForm}/>;
            break;

        default:
            formComponent = null;
    }
    return (
        <Div
            sx={{
                minHeight: "70vh"
            }}
        >
            {formData?.data?.isXfa ?  formComponent : <PdfFormPreview formData={formData} setPreviousFormData={()=>{}}/>}
        </Div>
    );
};

export default FormDetailsTab;
